import { createSelector } from "reselect";
import { Selectors } from "@grandvisionhq/configurator";
import { getFrameSku } from "../../../configurator/state/configurator/selectors.js";
import { getFrames } from "../../../products/state/products/selectors.internal.js";
const stepMapping = {
  lensType: "LensType",
  prescription: "LensPrescription",
  prescriptionValidation: "LensReview",
  lensPackage: "LensBundle",
  lensAddOn: "Addons"
};
const getProduct = createSelector(
  getFrameSku,
  getFrames,
  (frameSku, frames) => {
    if (!frameSku) {
      return void 0;
    }
    const frame = frames[frameSku];
    if (!frame) {
      return void 0;
    }
    return frame;
  }
);
const getConfigFlow = createSelector(
  Selectors.getCurrentStep,
  (stepData) => {
    if (!stepData) {
      return void 0;
    }
    return {
      version: "1.0",
      stepName: stepMapping[stepData.name]
    };
  }
);
export {
  getConfigFlow,
  getProduct
};
//# sourceMappingURL=selectors.js.map
